/*
 * only Javascript, without jquery!
 */

if (typeof window.SportFrame === "undefined") {
	window.SportFrame = new (function () {
		this.styleSetTimer = null;
		this.elem = null;
		/*        this.healthCheckInterval = null,*/
		this.betslip = null;
		this.isMaintenance = false;
		this.healthCheckUrl = "";
		(this.socket = {}), (this.maintanancePagePath = "");
		this.supportedPages = {
			home: "Home",
			upcoming: "Upcoming",
			results: "Results",
			gameDetails: "GameDetails",
			error404: "Error",
			search: "Search",
			liveSchedule: "LiveSchedule",
			multiView: "MultiView",
			multiBet: "MultiBet",
			scheduleEvents: "ScheduledEvents",
			liveEvents: "LiveEvents",
			league: "League",
			myTournaments: "MyTournaments",
		};
		this.commands = {
			setCssAsText: "setCssAsText",
			couponStakeCount: "couponStakeCount",
			customCssVariables: "customCssVariables",
			deposit: "deposit",
			expressdayShow: "expressdayShow",
			fixHeight: "fixHeight",
			heightChanged: "heightChanged",
			setBookingNumber: "setBookingNumber",
			loaded: "loaded",
			login: "login",
			moveBetslipBtn: "moveBetslipBtn",
			navigateToBetSlip: "navigateToBetSlip",
			navigateToBetHistory: "navigateToBetHistory",
			navigateToChampionship: "navigateToChampionship",
			navigateToEvent: "navigateToEvent",
			openPage: "openPage",
			registration: "registration",
			reload: "reload",
			scroll: "scroll",
			scrollTo: "scrollTo",
			scrollToTop: "scrollToTop",
			sportBalance: "sportBalance",
			statusError: "statusError",
			statusOk: "statusOk",
			withdraw: "withdraw",
			setTheme: "setTheme",
			setProjectTheme: "setProjectTheme",
			checkAndValidate: "checkAndValidate",
			sportAppEventListener: "sportAppEventListener",
			/*
			 * this.setts.eventsHandler types
			 */
			successBet: "successBet",
			navigateToSport: "navigateToSport",
			setCouponFromBookingNumber: "setCouponFromBookingNumber",
			sportAppEventDispatch: "sportAppEventDispatch",
		};

		this.setts = {
			server: "",
			sportPartner: "",
			token: "-",
			userId: "",
			champId: "", // TODO: change type to int
			eventId: "", // TODO: change type to int
			stakeId: "", // TODO: change type to int
			isLive: null, // TODO: change type to boolean
			isSuperTip: false,
			oddsFormat: NaN, // TODO: change type to int
			oddsFormatList: [], // TODO: change type to int
			device: "d",
			language: "",
			customCssUrl: "",
			sportsBookView: "",
			currentPage: "/Home",
			defaultPath: "SportsBook",
			terminalPath: "Terminal",
			scrollToTopInterval: null,
			timeZone: "", // TODO: change type to int
			fixedHeight: false,
			betslipBookNumber: 0,
			betslipCopyLinkUrl: "",
			clearSiteStyles: false,
			login: "", // TODO: change type to function
			deposit: "", // TODO: change type to function
			registration: "", // TODO: change type to function
			onContentLoaded: "", // TODO: change type to function
			healthCheckCallback: "", // TODO: change type to function
			bookingNumber: 0,
			balanceChangeCallback: () => {},
			onNavigateCallback: () => {},
			getSportAppRoute: () => {},
			eventsHandler: () => {},
			getBookingNumber: () => {},
			parent: [],
			/* for development use only */
			resetAllStyles: false,
			theme: "",
			projectTheme: "",
			pushStateDisabled: false,
			initialRoute: {
				path: "",
				qs: {},
				hashData: "",
			},
		};

		/* private members */
		this.buildUrl = () => {
			var sets = this.setts;
			var searchParams = new URLSearchParams();
			var result = this.setts.serverWithPath + sets.defaultPath;

			if (typeof sets.currentPage !== "undefined" && sets.initialRoute.path === "") {
				if (sets.currentPage.length <= 2) {
					// Temporary route fix.
					switch (sets.currentPage) {
						case "0":
							sets.currentPage = "Home";
							break;
						case "1":
							sets.currentPage = "Upcoming";
							break;
						case "2":
							sets.currentPage = "GameDetails";
							sets.isLive = true;
							break;
						case "3":
							sets.currentPage = "Results";
							break;
						case "4":
							sets.currentPage = "GameDetails";
							break;
						case "7":
							sets.currentPage = "BetsHistory";
							break;
						case "8":
							sets.currentPage = "GameDetails";
							sets.isLive = false;
							break;
						case "10":
							sets.currentPage = "Calendar";
							break;
						case "11":
							sets.currentPage = "MultiView";
							break;
						case "12":
							sets.currentPage = "Overview";
							break;
						case "13":
							sets.currentPage = "Schedule";
							break;
						case "19":
							sets.currentPage = "BetHistory";
							break;
						case "20":
							sets.currentPage = "BonusPage";
							break;
						case "21":
							sets.currentPage = "Favorites";
							break;
						case "22":
							sets.currentPage = "TeamDetails";
							break;
						default:
							sets.currentPage = "Home";
							break;
					}
				}

				var currentpage = sets.currentPage.toLowerCase();

				if (currentpage === "eventview") {
					sets.currentPage = "GameDetails";
					sets.isLive = true;
				}

				if (currentpage === "upcomingdetails") {
					sets.currentPage = "GameDetails";
					sets.isLive = false;
				}

				if (sets.device === "m" && currentpage === "overview") {
					sets.currentPage = "MultiView";
				}

				result += "/" + sets.currentPage;
			} else if (sets.initialRoute && sets.initialRoute.path) {
				switch (sets.initialRoute.path) {
					case "/pre-match":
						sets.currentPage = "Home";

						var sportObject = {};

						if (
							(sets.initialRoute.qs && sets.initialRoute.qs.q) ||
							typeof sets.initialRoute.hashData === "string"
						) {
							if (
								typeof sets.initialRoute.hashData === "string" &&
								sets.initialRoute.hashData.length > 0
							) {
								sportObject = JSON.parse(
									this.universalDecode(sets.initialRoute.hashData) || "{}"
								);
							} else if (sets.initialRoute.qs.q) {
								sportObject = JSON.parse(sets.initialRoute.qs.q || "{}");
							}

							var sportId = Object.keys(sportObject)[0];

							var nestedObject = sportObject[sportId];

							if (nestedObject) {
								var counryId = Object.keys(nestedObject)[0];

								if (counryId) {
									var championshipId = nestedObject[counryId][0];

									searchParams.append("championshipId", championshipId);
									searchParams.append("sportId", sportId);
									searchParams.append("counryId", counryId);
									searchParams.append("isLive", false);
									searchParams.append("isSuperTip", false);

									if (championshipId) {
										sets.currentPage = "Upcoming";
									}
								}
							}
						}
						break;
					case "/live":
						sets.currentPage = "Home";
						break;
					case "/event-details":
						sets.currentPage = "GameDetails";
						if (sets.initialRoute.qs) {
							var evendData = sets.initialRoute.qs;

							searchParams.append("gameId", evendData.event);
							searchParams.append("championshipId", evendData.champ);
							searchParams.append("isLive", !!Number(evendData.live));
							searchParams.append("isSuperTip", !!Number(evendData.supertip));
						}
						break;
					case "/results":
						sets.currentPage = "Results";
						break;
					case "/bet-race":
						sets.currentPage = "BetRace";
						break;
					case "/error":
						sets.currentPage = "Error";
						break;
					case "/calendar":
						sets.currentPage = "Calendar";
						break;
					case "/favorites":
						sets.currentPage = "MultiView";
						break;
					case "/overview":
						sets.currentPage = "Overview";
						break;
					case "/schedule":
						sets.currentPage = "Schedule";
						break;
					case "/league":
						sets.currentPage = "League";
						break;
					case "/sport-tournament":
						sets.currentPage = "TournamentsHistory";
						break;
					case "/live-streaming":
						sets.currentPage = "LiveStreaming";
						break;
					case "/group-stage":
						sets.currentPage = "GroupStage";
						break;
					case "/bet-history":
						sets.currentPage = "BetHistory";
						break;
					case "/bonus-history":
						sets.currentPage = "BonusPage";
						break;
					case "/team-details":
						sets.currentPage = "TeamDetails";
						if (sets.initialRoute.qs) {
							var evendData = sets.initialRoute.qs;

							searchParams.append("eventId", evendData.event);
							searchParams.append("competitorId", evendData.competitorId);
						}
						break;
					case "/favorites-page":
						sets.currentPage = "Favorites";
						break;
					default:
						sets.currentPage = "Home";
						break;
				}

				searchParams.append("initialRoute", JSON.stringify(sets.initialRoute));
				result += "/" + sets.currentPage;
			} else {
				result += "/Home";
			}

			if (sets.eventId && sets.eventId != "0" && !sets.competitorId) {
				searchParams.append("gameId", sets.eventId);
				searchParams.append("isLive", sets.isLive);
				searchParams.append("isSuperTip", sets.isSuperTip);

				if (sets.stakeId) {
					searchParams.append("stakeId", sets.stakeId);
				}
			} else if (sets.competitorId) {
				searchParams.append("competitorId", sets.competitorId);
				if (sets.eventId) {
					searchParams.append("eventId", sets.eventId);
				}
			} else if (sets.champId) {
				searchParams.append("championshipId", sets.champId);
			}

			searchParams.append("token", sets.token);

			if (sets.partnerUserId) {
				searchParams.append("partnerUserId", sets.userId);
			}

			searchParams.append("d", sets.device);
			searchParams.append("l", sets.language);
			searchParams.append("tz", sets.timeZone);
			searchParams.append("betslipBookNumber", sets.betslipBookNumber);
			searchParams.append("betslipCopyLinkUrl", sets.betslipCopyLinkUrl);
			searchParams.append("of", Number.isNaN(sets.oddsFormat) ? "" : sets.oddsFormat);

			if (Array.isArray(sets.oddsFormatList)) {
				searchParams.append("ofl", encodeURIComponent(sets.oddsFormatList));
			}

			if (Array.isArray(sets.parent)) {
				for (var i = 0; i < sets.parent.length; i++) {
					searchParams.append("parent", sets.parent[i]);
				}
			}

			searchParams.append("customCssUrl", sets.customCssUrl);
			searchParams.append("sportsBookView", sets.sportsBookView);
			searchParams.append("clearSiteStyles", sets.clearSiteStyles);
			searchParams.append("resetAllStyles", sets.resetAllStyles);
			searchParams.append("theme", sets.theme);
			searchParams.append("projectTheme", sets.projectTheme);
			searchParams.append("pushStateDisabled", sets.pushStateDisabled);

			return result + "?" + searchParams.toString();
		};
		this.fromStringToFunction = (callbackFunction) => {
			switch (typeof callbackFunction) {
				case "function":
					return callbackFunction;

				case "string":
					callbackFunction = callbackFunction.split(".");
					var currentWrapperObject = window;

					for (var i = 0; i < callbackFunction.length; i++) {
						if (currentWrapperObject !== undefined) {
							currentWrapperObject = currentWrapperObject[callbackFunction[i]];
						}
					}

					return this.fromStringToFunction(currentWrapperObject);

				default:
					return () => {};
			}
		};
		this.getBounds = () => {
			var clientRect = document.documentElement.getBoundingClientRect();
			var sfClientRect = this.elem.getBoundingClientRect();

			var bounds = {
				visibleArea: {
					top: clientRect.top,
					height: window.innerHeight,
				},

				sportIframe: {
					top: sfClientRect.top,
					height: sfClientRect.height,
				},
			};

			return bounds;
		};
		this.listenMessage = (e) => {
			switch (e.data.command) {
				case this.commands.loaded:
					this.riseContentloaded();
					this.setFixedHeight();
					this.setCouponFromBookingNumber();
					this.scroll();
					break;

				case this.commands.expressdayShow:
					var elem = document.getElementById("MultiBetofTheDayPanel");

					if (elem) {
						if (e.data.args) {
							elem.style.display = "";
						} else {
							elem.style.display = "none";
						}
					}
					break;

				case this.commands.couponStakeCount:
					if (this.betslip) {
						var countCont = this.betslip.querySelector("#footer_coupon_count");
						if (countCont) {
							countCont.innerHTML = e.data.args;
						}
					}
					break;

				case this.commands.moveBetslipBtn:
					if (this.betslip) {
						this.betslip.innerHTML = e.data.args;

						var coupon = this.betslip.querySelector("#footer_coupon_div");
						if (coupon) {
							coupon.addEventListener("click", (ev) => {
								ev.preventDefault();
								ev.stopPropagation();
								this.sendMessage(this.commands.navigateToBetSlip, true);
							});
						}

						var bethistorybutton = this.betslip.querySelector("#footer_bet_history");
						if (bethistorybutton) {
							bethistorybutton.addEventListener("click", (ev) => {
								ev.preventDefault();
								ev.stopPropagation();
								this.sendMessage(this.commands.navigateToBetHistory, true);
							});
						}
					}
					break;

				case this.commands.login:
					if (this.setts.login) {
						this.fromStringToFunction(this.setts.login)();
					}
					break;

				case this.commands.registration:
					if (this.setts.registration) {
						this.fromStringToFunction(this.setts.registration)();
					}
					break;

				case this.commands.deposit:
					if (this.setts.deposit) {
						this.fromStringToFunction(this.setts.deposit)();
					}
					break;

				case this.commands.withdraw:
					if (this.setts.withdraw) {
						this.fromStringToFunction(this.setts.withdraw)();
					}
					break;

				case this.commands.scrollTo:
					if (e.data.args !== undefined) {
						setTimeout(() => {
							window.scrollTo(0, e.data.args + 100);
						}, 0);
					}
					break;

				case this.commands.scrollToTop:
					if (this.setts.scrollToTopInterval) {
						clearInterval(this.setts.scrollToTopInterval);
					}
					this.setts.scrollToTopInterval = setInterval(this.scrollToTop, 5);
					break;

				case this.commands.reload:
					window.location.reload(true);
					break;

				case this.commands.heightChanged:
					if (e.data.args) {
						this.setHeight(e.data.args);
					}
					break;

				case this.commands.setBookingNumber:
					if (e.data.args.BookNumber) {
						this.setts.getBookingNumber(e.data.args.BookNumber);
					}
					break;

				case this.commands.sportBalance:
					var bo = JSON.parse(decodeURIComponent(e.data.args));
					var sportBonusPanel = document.getElementById("SportBonusPanel");
					var cashbackBalancePanel = document.getElementById("CashbackBalancePanel");
					var tournamentBalancePanel = document.getElementById("TournamentBalancePanel");

					if (typeof bo === "object") {
						if (sportBonusPanel) {
							var sportBonusAmount =
								sportBonusPanel.querySelector("#SportBonusAmount");

							if (sportBonusAmount) {
								if (parseFloat(bo.BonusBalance) >= 0) {
									sportBonusPanel.style.display = "";
									sportBonusPanel.classList.remove("dis_none");
									sportBonusAmount.innerHTML = bo.BonusBalance;
								} else {
									sportBonusPanel.style.display = "none";
									sportBonusAmount.innerHTML = "";
								}
							}
						}

						if (cashbackBalancePanel) {
							var cashbackBalanceAmount =
								cashbackBalancePanel.querySelector("#CashbackBalanceAmount");

							if (cashbackBalanceAmount) {
								if (parseFloat(bo.CashBackBalance) >= 0) {
									cashbackBalancePanel.style.display = "";
									cashbackBalancePanel.classList.remove("dis_none");
									cashbackBalanceAmount.innerHTML = bo.CashBackBalance;
								} else {
									cashbackBalancePanel.style.display = "none";
									cashbackBalanceAmount.innerHTML = "";
								}
							}
						}

						if (tournamentBalancePanel) {
							if (!tournamentBalancePanel.clickHandled) {
								tournamentBalancePanel.clickHandled = true;
								tournamentBalancePanel.addEventListener("click", () => {
									this.openPage(this.supportedPages.myTournaments);
								});
							}

							var tournamentBalanceAmount = tournamentBalancePanel.querySelector(
								"#TournamentBalanceAmount"
							);

							if (tournamentBalanceAmount) {
								if (parseFloat(bo.TournamentBalance) >= 0) {
									tournamentBalancePanel.style.display = "";
									tournamentBalancePanel.classList.remove("dis_none");
									tournamentBalanceAmount.innerHTML = bo.TournamentBalance;
								} else {
									tournamentBalancePanel.style.display = "none";
									tournamentBalanceAmount.innerHTML = "";
								}
							}
						}

						this.setts.balanceChangeCallback({
							BonusBalance: bo.BonusBalance,
							CashBackBalance: bo.CashBackBalance,
							TournamentBalance: bo.TournamentBalance,
						});
					}
					break;

				case this.commands.statusOk:
					if (this.setts.healthCheckCallback) {
						this.fromStringToFunction(this.setts.healthCheckCallback)("status-ok");
					}
					break;

				case this.commands.statusError:
					if (this.setts.healthCheckCallback) {
						this.fromStringToFunction(this.setts.healthCheckCallback)("status-error");
					}
					break;

				case this.commands.navigateToEvent:
					this.setts.onNavigateCallback(e.data.args);
					break;

				case this.commands.sportAppEventDispatch:
					this.setts.getSportAppRoute(e.data.args);
					break;

				case this.commands.successBet:
				case this.commands.navigateToSport:
					var args = {
						sender: e.data.sender,
						eventType: e.data.command,
						data: e.data.args,
					};

					this.setts.eventsHandler(args);
					break;

				case this.commands.checkAndValidate:
					var status = e.data.args.error.status;

					this.checkAndValidate(status === 403);
					break;
			}
		};
		this.riseContentloaded = () => {
			if (typeof this.setts.onContentLoaded !== "undefined" && this.setts.onContentLoaded) {
				var wnd = window,
					arrr = this.setts.onContentLoaded.split(".");

				for (var i = 0; i < arrr.length; i++) {
					wnd = wnd[arrr[i]];
				}

				if (typeof wnd === "function") {
					setTimeout(wnd, 0);
				}
			}
		};
		this.setFixedHeight = () => {
			//    if (this.setts.fixedHeight) {
			//        this.sendMessage(this.commands.fixHeight, this.setts.fixedHeight);
			//    }
		};
		this.sendMessage = (commandType, vars, restPostData) => {
			restPostData = restPostData || {};
			var dataToPost = Object.assign({ command: commandType, variables: vars }, restPostData);
			this.elem.contentWindow && this.elem.contentWindow.postMessage(dataToPost, "*");
		};
		this.scroll = () => {
			var bounds = this.getBounds();
			var dataToPost = {
				type: "bounds",
				data: {
					bounds: bounds,
				},
			};

			this.sendMessage(this.commands.scroll, bounds, dataToPost);
		};
		this.scrollToTop = () => {
			var clientRect = document.documentElement.getBoundingClientRect();

			if (clientRect.top < 0) {
				window.scrollBy(0, -10);
			} else {
				clearInterval(this.setts.scrollToTopInterval);
			}
		};
		this.setHeight = (data) => {
			if (!this.setts.fixedHeight && this.elem && typeof data === "object") {
				var localVar = data.height;

				if (data.av !== 0 && data.av !== 13 && data.av !== 16 && !data.IsMobile) {
					if (window.document.body.style.overflowY !== "hidden") {
						setTimeout(() => {
							clearInterval(this.setts.scrollToTopInterval);
							this.setts.scrollToTopInterval = setInterval(this.scrollToTop, 5);
						}, 50);
					}

					window.document.body.style.overflowY = "hidden";
					localVar = window.innerHeight - this.elem.getBoundingClientRect().top;
				} else {
					window.document.body.style.overflowY = "";
				}

				this.elem.style.height = localVar + "px";
				this.elem.height = localVar;
			}
		};
		this.addEventListeners = () => {
			/*** add event listeners ** */
			if (window.postMessage) {
				window.addEventListener("message", this.listenMessage);
			}

			if (this.setts.device !== "m") {
				window.addEventListener("resize", this.onHeightChange);
			}

			if (window.scroll) {
				window.addEventListener("scroll", this.scroll);
			}

			if (window.onerror) {
				//disable all errors for affected site
				window.onerror = () => {
					return true;
				};
			}

			const resizeObserver = new ResizeObserver(this.onHeightChange);
			resizeObserver.observe(document.body);
		};
		this.removeEventListeners = () => {
			if (!this.backUpSettings) {
				this.backUpSettings = Object.create(this.setts);
			}

			this.setts = Object.create(this.backUpSettings);

			window.removeEventListener("message", this.listenMessage);
			window.removeEventListener("scroll", this.scroll);
			window.removeEventListener("resize", this.onHeightChange);
		};
		this.checkAndValidate = (bypassCheck) => {
			if (bypassCheck) {
				return this.validate();
			}

			var tryCount = sessionStorage.getItem("__sb_err_cnt__");
			tryCount = parseInt(tryCount);

			if (isNaN(tryCount)) {
				tryCount = 0;
			}

			var self = this;

			if (tryCount < 3) {
				fetch(this.setts.serverWithPath + "Error/Check", {
					method: "GET",
					mode: "cors",
					credentials: "include",
				})
					.then((e) => {
						let server = null;

						if (e && e.headers && e.headers.get) {
							server = e.headers.get("server");
						}

						if ((!server || server === "cloudflare") && e.status === 403) {
							sessionStorage.setItem("__sb_err_cnt__", ++tryCount);
							self.validate(e);
						}
					})
					.catch((e) => {
						sessionStorage.setItem("__sb_err_cnt__", ++tryCount);
						self.validate(e);
					});
			}
		};
		this.validate = () => {
			location.href =
				this.setts.serverWithPath +
				"Error/Validate?returnUrl=" +
				encodeURIComponent(location.href);
		};
		this.destroy = () => {
			this.removeEventListeners();
			/*   clearInterval(this.healthCheckInterval);*/
			this.socket.close && this.socket.close();
			if (this.elem instanceof Element) {
				this.elem.remove();
				this.elem = null;
			}
		};

		this.removePreviousBetSlip = () => {
			var betSlipRootId = "betslip-root-inner";
			var previousBetSlipContainer = document.getElementById(betSlipRootId);

			if (previousBetSlipContainer) {
				previousBetSlipContainer.remove();
			}
		};

		/**
		 * The starting point.
		 * @param {Array} params - The main config object
		 * @public
		 */

		this.frame = (params) => {
			this.removeEventListeners();

			this.removePreviousBetSlip();

			var typeExceptions = ["login", "deposit", "registration"];

			for (var r = 0; r < params.length; r++) {
				var itemKey = params[r][0],
					itemValue = params[r][1],
					itemType = typeof itemValue;

				if (
					typeof this.setts[itemKey] === itemType ||
					(typeExceptions.indexOf(itemKey) > -1 && itemType === "function")
				) {
					this.setts[itemKey] = itemValue;
				}
			}

			if (!this.setts.server.endsWith("/")) {
				this.setts.server += "/";
			}

			if (this.setts.sportPartner) {
				this.setts.serverWithPath =
					this.setts.server + this.setts.sportPartner.toLowerCase() + "/";
			} else {
				this.setts.serverWithPath = this.setts.server;
			}

			this.checkAndValidate(false);

			var wrapper = document.getElementById("sport_div_iframe");

			if (wrapper === null) {
				wrapper = document.createElement("div");
				document.body.appendChild(wrapper);
			}

			var height = 600;

			/// temporary disable fixed height for mobile devices
			this.setts.fixedHeight = !!this.setts.fixedHeight && this.setts.device !== "m";

			if (this.setts.fixedHeight) {
				height = this.setts.fixedHeight = Math.max(
					height,
					window.innerHeight - wrapper.getBoundingClientRect().top
				);
			} else if (this.setts.device === "m") {
				height = 300;
			}

			if (!(this.elem instanceof Element)) {
				this.elem = document.createElement("iframe");
			}

			this.elem.setAttribute("frameborder", "0");
			this.elem.setAttribute("allowfullscreen", "");
			this.elem.setAttribute("allow", "web-share; autoplay; clipboard-write");
			this.elem.scrolling = "no";
			this.elem.width = 1;
			this.elem.height = height;
			this.elem.style.minWidth = "100%";
			this.elem.style.minHeight = height + "px";
			this.elem.style.height = height + "px";
			this.elem.style.display = "block";
			this.elem.src = this.buildUrl();

			if (this.setts.device === "m") {
				this.betslip = document.createElement("div");
				this.betslip.id = "betSlip";
				this.betslip.style.position = "fixed";
				this.betslip.style.width = "100%";
				this.betslip.style.textAlign = "center";
				this.betslip.style.bottom = "10px";
				this.betslip.style.zIndex = "99";

				((s, p, o, r, t) => {
					r = s.createElement(p);
					t = s.getElementsByTagName("head")[0];
					r.rel = "stylesheet";
					r.href = o;
					t.appendChild(r);
				})(document, "link", this.setts.server + "Css/CouponButton.css");
			}

			try {
				this.getRequest(
					this.setts.serverWithPath + "staticcontent/globalsettings.js",
					(status, response) => {
						if (
							status === "error" ||
							!response ||
							!response.publicApis ||
							!response.publicApis.HealthCheckUrlSocket
						) {
							wrapper.appendChild(this.elem);

							if (this.setts.device === "m") {
								wrapper.appendChild(this.betslip);
							}

							return;
						}

						this.healthCheckUrl = response.publicApis.HealthCheckUrlSocket;

						if (this.setts.sportPartner) {
							this.healthCheckUrl += "&systemRID=" + this.setts.sportPartner;
						}

						this.maintanancePagePath =
							this.setts.serverWithPath + "staticcontent/index";

						this.isMaintenanceAvailable();
					}
				);
			} catch (e) {
				console.log(e);
			}

			wrapper.appendChild(this.elem);

			if (this.setts.device === "m") {
				wrapper.appendChild(this.betslip);
			}

			this.addEventListeners();
		};

		/**
		 * Open the corresponding page without reload.
		 * @param {String} pageName - The name of the page.
		 * @public
		 */
		this.openPage = (pageName) => {
			return this.sendMessage(this.commands.openPage, pageName);
		};

		/**
		 * Open the corresponding event without reload. Supported event types: [sport | championship | tournament | match]
		 * @param {Object} ev - The routing object.
		 * @param {number} ev.sportId - The id of the sport item.
		 * @param {?number} ev.championshipId - The id of the championship item.
		 * @param {?number} ev.tournamentId - The id of the tournament item.
		 * @param {?number} ev.matchId - The id of the match item.
		 * @param {string} ev.eventStatus - Supported statuses: "live" | "prematch".
		 * @example
		 * {
		 *    sportId: 1,
		 *	  championshipId: 2448,
		 *	  tournamentId: 2580,
		 *	  matchId: 5222,
		 *	  eventStatus: "live"
		 * }
		 * @public
		 */
		this.openEvent = (ev) => {
			if (typeof ev === "object" && typeof ev.sportId === "number") {
				this.sendMessage(this.commands.navigateToEvent, ev);
			}
		};

		/**
		 * Sets coupon when booking number is provided.
		 * @param {Number} bookingNumber - The booking number of coupon.
		 * @public
		 */
		this.setCouponFromBookingNumber = () => {
			if (this.setts.bookingNumber) {
				return this.sendMessage(
					this.commands.setCouponFromBookingNumber,
					this.setts.bookingNumber
				);
			}
		};

		/**
		 * @param {Object} colorSet - CSS valiables as object keys.
		 * @return {Boolean} - boolean value.
		 * @example
		 * {
		 *    "brand-color-1": "#894d37",
		 *	  "background-color-1": "#4D4D4D",
		 *	  "text-color-1": "#222"
		 * }
		 * @public
		 * */
		this.setStyle = (colorSet) => {
			if (this.styleSetTimer) {
				clearTimeout(this.styleSetTimer);
			}

			this.styleSetTimer = setTimeout(
				this.sendMessage,
				50,
				this.commands.customCssVariables,
				colorSet
			);

			return true;
		};

		this.setCssAsText = (cssText) => {
			this.sendMessage(this.commands.setCssAsText, cssText);
		};

		this.setTheme = (theme) => {
			this.sendMessage(this.commands.setTheme, theme);
		};

		this.setSportAppRoute = (data) => {
			this.sendMessage(this.commands.sportAppEventListener, data);
		};

		this.setProjectTheme = (projectTheme) => {
			this.sendMessage(this.commands.setProjectTheme, projectTheme);
		};

		this.getRequest = (url, callback) => {
			var xhr = new XMLHttpRequest();

			xhr.responseType = "json";
			xhr.open("GET", url, true);

			xhr.onload = () => {
				if (xhr.status === 200) {
					callback("success", xhr.response);
				} else {
					callback("error: " + xhr.status);
				}
			};

			xhr.send();
		};

		this.checkMaintenance = (isMaintenanceAvailble) => {
			var t = this;
			let src = t.buildUrl();

			if (isMaintenanceAvailble && !t.isMaintenance) {
				t.elem.src = t.maintanancePagePath;
				t.isMaintenance = true;
			} else if (!isMaintenanceAvailble && t.isMaintenance) {
				t.elem.src = src;
				t.isMaintenance = false;
			}
		};
		this.isMaintenanceAvailable = () => {
			var t = this;
			t.socket = new WebSocket(t.healthCheckUrl);

			t.socket.onmessage = async (event) => {
				t.checkMaintenance && t.checkMaintenance(event.data === "true");
			};

			t.socket.onerror = () => {
				t.checkMaintenance && t.checkMaintenance(false);
			};
		};

		this.onHeightChange = () => {
			if (this.heightUpdateTimer) {
				clearTimeout(this.heightUpdateTimer);
			}

			this.heightUpdateTimer = setTimeout(this.setFrameHeight, 50);
		};

		this.setFrameHeight = () => {
			const target = this.elem;
			const topOffset = target.getBoundingClientRect().top || target.offsetTop;
			const height = window.innerHeight - topOffset;

			target.height = height;
			target.style.minHeight = target.style.height = height + "px";
		};

		this.universalDecode = (base64) => {
			try {
				const jsonString = decodeURIComponent(
					atob(base64)
						.split("")
						.map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
						.join("")
				);
				return JSON.parse(jsonString);
			} catch (e) {
				return "";
			}
		};
	})();
}
